import { useEffect, useState } from 'react'

type IUseDurationProps = {
  url?: string
  duration?: number
  setLoadingMD?: (value: boolean) => void
}

export const useDuration = ({ url, duration, setLoadingMD }: IUseDurationProps) => {
  const [time, setTime] = useState(duration || 0)

  useEffect(() => {
    if (!duration) {
      if (url) {
        setLoadingMD?.(true)

        const audio = new Audio(url)
        audio.preload = 'metadata'

        const onLoaded = () => {
          setTime(audio.duration)
          setLoadingMD?.(false)
        }
        const onError = () => setLoadingMD?.(false)

        audio.addEventListener('loadedmetadata', onLoaded)
        audio.addEventListener('error', onError)

        return () => {
          audio.removeEventListener('loadedmetadata', onLoaded)
          audio.removeEventListener('error', onError)
          audio.src = ''
        }
      }

      return
    }

    setTime(duration)
  }, [duration, url])

  return {
    time: time,
    setTime: setTime,
  }
}
